import React from 'react';
import { AvatarSize } from '@parkschannel/ui';
import classNames from 'classnames';

export interface CardAvatarProps {
  children?: React.ReactNode;
  size?: AvatarSize;
  backgroundClassName?: string;
}

export const CardAvatar: React.FC<CardAvatarProps> = ({
  children,
  size = '2xl',
  backgroundClassName,
}) => {
  return (
    <div
      className={classNames(
        'bg-neutral-100 rounded-full w-fit h-fit backdrop-blur-md group',
        backgroundWidth(size),
        backgroundClassName
      )}
    >
      <div className="relative overflow-hidden rounded-full">{children}</div>
    </div>
  );
};

function backgroundWidth(size: AvatarSize) {
  switch (size) {
    case 'xs':
      return 'p-1';
    case 'sm':
      return 'p-1';
    case 'md':
      return 'p-1';
    case 'lg':
      return 'p-2';
    case 'xl':
      return 'p-2';
    case '2xl':
      return 'p-3';
    default:
      return 'p-5';
  }
}
